import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-uikit/Typography";
import { BillingDetailsContainer } from "./BillingDetailsContainer";

export const UpcomingInvoice = () => (
  <BillingDetailsContainer>
    <Typography.LabelXl>
      {t("settings.billing.manage_billing.upcoming_invoice.title")}
    </Typography.LabelXl>
  </BillingDetailsContainer>
);
